<wms-dialog-header title="{{locale['LABEL_SESSION_TIMEOUT']}}"></wms-dialog-header>
<wms-dialog-body>
  <form enctype="multipart/form-data" class="wm-form" (keydown.enter)="login()" #loginForm="ngForm">
    <wms-message *ngIf="msgData.show" hideclose="true" [scopeDataset]="msgData"></wms-message>
    <p class="info">{{locale['SESSION_TIMEOUT_MESSAGE']}}</p>
    <div class="form-group app-composite-widget clearfix">
      <label class="control-label app-label required col-md-3">{{locale['LABEL_EMAIL']}}:</label>
      <div class="col-md-9">
        <input type="text" class="form-control app-textbox" [(ngModel)]="userData.email"
               placeholder="{{locale['PLACEHOLDER_ENTER_EMAIL']}}" name="email"/>
      </div>
    </div>
    <div class="form-group app-composite-widget clearfix">
      <label class="control-label app-label required col-md-3">
        {{locale['LABEL_PASSWORD']}}:
      </label>
      <div  class="col-md-9">
        <input type="password" class="form-control app-textbox" [(ngModel)]="userData.password"
               autofocus placeholder="{{locale['PLACEHOLDER_ENTER_PASSWORD']}}" name="password"/>
      </div>
    </div>
  </form>
</wms-dialog-body>
<wms-dialog-footer>
  <button class="button-primary btn app-button" title="{{locale.LABEL_LOGIN}}" (click)="login()" [disabled]="isLoginInProgress">
    <span class="btn-caption">{{locale.LABEL_LOGIN}}</span>
  </button>
</wms-dialog-footer>
